import React, { useState, useEffect } from 'react';
import IconWrapper from '/react4xp/components/Icon';
import { AccentArrow } from '/react4xp/components/Svg/Others/Icons';

interface Props {
    animationPath: string;
    label: string;
    href: string;
    target?: string;
}

export default function SolutionsIcon({ animationPath, label, href, target }: Props) {
    return (
        <a href={href} target={target} className="solutions__item">
            <div className="solutions__icon" data-animation-path={animationPath}></div>
            <div className="solutions__label">
                <p>{label}</p>
                <IconWrapper className='solutions__arrow' iconColor='text-light' IconComponent={AccentArrow} />
            </div>
        </a>
    );
}